import {AccountVulnerabilitiesFragment} from '../../schema-types/AccountVulnerabilitiesFragment';

import {getVulnerabilitiesFields} from './HeaderVulnerabilityFields';
import {investmentFieldsType, vulnerabilityFieldsType} from './postcursorFields';

export function getContactFieldValues(
  account: AccountVulnerabilitiesFragment
): investmentFieldsType & vulnerabilityFieldsType {
  const {primaryContact, secondaryContact} = account;
  const investFields: investmentFieldsType = {
    giaHasLiquidityNeeds: {},
    pensionHasLiquidityNeeds: {},
  };
  const vulnerability: vulnerabilityFieldsType = {
    isVulnerable: {},
    longTermVulnerabilityTypes: {},
    isEventVulnerable: {},
    eventVulnerabilityTypes: {},
    specialCareReasons: {},
  };

  if (account.isTrust) {
    const {id} = account;
    investFields.giaHasLiquidityNeeds[id] = account.giaHasLiquidityNeeds || false;
    investFields.pensionHasLiquidityNeeds[id] = account.pensionHasLiquidityNeeds || false;
  }

  if (primaryContact) {
    const {id} = primaryContact;
    const vulnerabilities = getVulnerabilitiesFields(primaryContact);
    investFields.giaHasLiquidityNeeds[id] = primaryContact.giaHasLiquidityNeeds || false;
    investFields.pensionHasLiquidityNeeds[id] =
      primaryContact.pensionHasLiquidityNeeds || false;
    vulnerability.specialCareReasons[id] = primaryContact.specialCareReasons;
    vulnerability.isVulnerable[id] =
      vulnerabilities.longTermVulnerabilityTypes.length > 0;
    vulnerability.isEventVulnerable[id] =
      vulnerabilities.eventVulnerabilityTypes.length > 0 ||
      !!primaryContact.specialCareReasons;
    vulnerability.eventVulnerabilityTypes[id] = vulnerabilities.eventVulnerabilityTypes;
    vulnerability.longTermVulnerabilityTypes[id] =
      vulnerabilities.longTermVulnerabilityTypes;
  }
  if (secondaryContact) {
    const vulnerabilities = getVulnerabilitiesFields(secondaryContact);
    const {id} = secondaryContact;
    investFields.giaHasLiquidityNeeds[id] =
      secondaryContact.giaHasLiquidityNeeds || false;
    investFields.pensionHasLiquidityNeeds[id] =
      secondaryContact.pensionHasLiquidityNeeds || false;
    vulnerability.specialCareReasons[id] = secondaryContact.specialCareReasons;
    vulnerability.isVulnerable[id] =
      vulnerabilities.longTermVulnerabilityTypes.length > 0;
    vulnerability.isEventVulnerable[id] =
      vulnerabilities.eventVulnerabilityTypes.length > 0 ||
      !!secondaryContact.specialCareReasons;
    vulnerability.eventVulnerabilityTypes[id] = vulnerabilities.eventVulnerabilityTypes;
    vulnerability.longTermVulnerabilityTypes[id] =
      vulnerabilities.longTermVulnerabilityTypes;
  }
  return {...investFields, ...vulnerability};
}
